// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1t-q";
export var animationRelative = "_1t-p";
export var backdropBlur = "_1t-0";
export var detailLabelCell = "_1t-12";
export var detailTable = "_1t-11";
export var detailValueCell = "_1t-13";
export var docIconBox = "_1t-1d";
export var docIconBoxMd = "_1t-1f";
export var docIconBoxSm = "_1t-1e";
export var docTypeRow = "_1t-16";
export var docTypeRowInner = "_1t-17";
export var dropdownMatchDatePicker = "_1t-3";
export var evidenceCardContent = "_1t-1c";
export var fileUploadSpin = "_1t-j";
export var gorgiasOpenButton = "_1t-15 _1t-d";
export var gorgiasTicketCard = "_1t-14";
export var heroModalFooterButton = "_1t-18";
export var hiddenContainer = "_1t-o";
export var iconPrimary = "_1t-1g";
export var iconSecondary = "_1t-1h";
export var iconTertiary = "_1t-1i";
export var integrationCard = "_1t-1";
export var integrationLogoBox = "_1t-2";
export var mainColumnSticky = "_1t-1b";
export var maxWidthContainer = "_1t-19";
export var modalContentBody = "_1t-a";
export var modalHeaderImage = "_1t-5";
export var modalImageLabel = "_1t-7";
export var modalImageOverlay = "_1t-6";
export var modalImageSubtitle = "_1t-9";
export var modalImageTitle = "_1t-8";
export var modalImageWrapper = "_1t-4";
export var modalStickyFooter = "_1t-b";
export var removeButton = "_1t-e";
export var sidebarColumn = "_1t-1a";
export var spinner = "_1t-i";
export var timelineLine = "_1t-y";
export var timelineLineBlack = "_1t-10 _1t-y";
export var timelineLineGray = "_1t-z _1t-y";
export var timelineLineHeight = "_1t-x";
export var tlDotActivate = "_1t-u";
export var tlDotActivateAnim = "_1t-t";
export var tlDotHide = "_1t-s";
export var tlDotHideAnim = "_1t-r";
export var tlLineActivate = "_1t-w";
export var tlLineActivateAnim = "_1t-v";
export var uploadHint = "_1t-n";
export var uploadIconBox = "_1t-k";
export var uploadLabel = "_1t-m";
export var uploadText = "_1t-l";
export var uploadZone = "_1t-f";
export var uploadZoneCursorDefault = "_1t-h";
export var uploadZoneCursorPointer = "_1t-g";
export var uploadedFileRow = "_1t-c";
export var viewButton = "_1t-d";